import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    itemText: {
      textTransform: 'uppercase',
    },
    root: {
      minWidth: 300,
    },
  }),
);

export default useStyles;
